/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { EmbersTypography } from '../../typography';
import { StyledColumnSectionGroup, StyledColumnSection } from './styles';
export var Columns = function Columns(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    wrapSize = _ref.wrapSize,
    _ref$wrapSelectionDir = _ref.wrapSelectionDirection,
    wrapSelectionDirection = _ref$wrapSelectionDir === void 0 ? 'column' : _ref$wrapSelectionDir;
  var renderLogo = function renderLogo(item) {
    var logo = item.logo;
    if (logo) {
      if (typeof logo === 'string') {
        return /*#__PURE__*/React.createElement("img", {
          src: logo,
          width: "52",
          height: "52",
          alt: ""
        });
      } else {
        return logo;
      }
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "EmbersTemplate-marketingColumns-selection-circle",
        style: {
          background: item.color
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon-".concat(item.iconName)
      }));
    }
  };
  return /*#__PURE__*/React.createElement(StyledColumnSectionGroup, {
    className: "EmbersTemplate-marketing-content EmbersTemplate-marketingColumns-root",
    wrapSize: wrapSize
  }, data.map(function (v, i) {
    var _v$titleProps, _v$titleProps2;
    return /*#__PURE__*/React.createElement(StyledColumnSection, {
      key: i,
      className: "EmbersTemplate-marketingColumns-selection-root",
      wrapSize: wrapSize,
      wrapDirection: wrapSelectionDirection
    }, renderLogo(v), /*#__PURE__*/React.createElement("div", {
      className: "EmbersTemplate-marketingColumns-selection-content"
    }, /*#__PURE__*/React.createElement(EmbersTypography, {
      className: "EmbersTemplate-marketingColumns-selection-title",
      variant: ((_v$titleProps = v.titleProps) === null || _v$titleProps === void 0 ? void 0 : _v$titleProps.variant) || 'headerE',
      componentType: ((_v$titleProps2 = v.titleProps) === null || _v$titleProps2 === void 0 ? void 0 : _v$titleProps2.componentType) || 'h2'
    }, v.title), /*#__PURE__*/React.createElement(EmbersTypography, {
      variant: "body",
      margin: 0,
      className: "EmbersTemplate-marketingColumns-selection-body"
    }, v.description)));
  }));
};